import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SpinnerOverlayService } from '../services/spinner/spinner-overlay.service';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';

const EXCLUDED_URL = 'PaymentGateway/SquareService/GetLocations';
const GETPROMOCODE_URL = 'PromoCodeService/GetAllPromocode';
const GETEVENT_URL = 'EventService/GetAllEvent';
const GETSELLTICKET_URL = 'OrderManagement/SellTickets';
const CHECKSITESUSPENDED_URL = 'CheckSiteSuspended';
const UPDATEVENUEMODIFYDATE_URL = 'UpdateVenueModifyDate';
const ISDOMAINEXIST_URL = 'IsDomainAvailable';
const UPDATEEMBEDBUTTON_URL = 'UpdateEmbedButton';
const COMMONDETAILS_URL = 'CommonService/GetCommonDetails';
const GETPAGEVIEWS_URL = 'GoogleAnalytics/GetPageViews';
const CALCULATEAVAILABLESEAT_URL = 'EventService/CalculateAvailableSeat';
const GETPAGEDATA_URL = 'OrderManagement/GetPageData';
const GETDASHBOARD_URL = 'Dashboard/GetDashboard';
const GETATTENDEEMANAGEMENT_URL = 'AttendeeManagement/GetAttendeeManagement';
const BOXOFFICEPRINTETICKET_URL = 'AttendeeManagement/GetPrintAllTicketsDetails';
const GETTIMESLOTS_URL = 'CommonService/GetTimeSlots';
const GETIMPORTATTENDEES_URL = 'AttendeeManagement/GetEventDataForImportAttendee';
const PRINTBADGE_URL = 'Badge/';
const ATTENDEEBADGEPRINT_URL = 'Badge/AttendeeBadgesPrint';
const GETADMISSIONDETAIL_URL = 'OrderManagement/GetAdmissionDetail';
const SCANRESETTICKET_URL = 'AttendeeManagement/ScanResetTicket';
const GETEVENTINFOTOSWITCH = 'OrderManagement/GetEventTimeDetailsToSwitch';
const CHECKPREVALIDATIONTOTIME = 'OrderManagement/CheckPreValidationToCreateTime';
const GETPROMOCODES = 'PromoCodeService/GetAllPromocode';
const EXCLUDED_URL_CHATGPT_AI = 'SettingService/SaveChatgptRequestRecord';
const EXCLUDED_URL_CHATGPT_AI_DELETE_RECORD = 'SettingService/DeleteChatGptRequest';
const EXCLUDED_URL_FOR_ARCHIVE = 'EventService/UpdateEnableSaleForGaAndRSEventTime';
const EXCLUDED_GETEVENTIMAGESBYTITLE = 'EventService/GetEventImagesByTitle';
const GETACTIVEVENTPOSTEMAIL = 'ScheduledEmailJob/GetActiveEventForPostEventRecommendation';
const GETSCANREPORT_URL = 'Report/GetScanReportByTimeAndShowId';
const GETMAKETEMPLATEJSON_URL = 'SettingService/GetMakeTemplateJson';
const GETGAANDRSEVENTSFORBOOKINGLAYOUT_URL = 'OrderManagement/GetGAAndRSEventsForBookingLayout';
const GETSTATES_URL = 'EventService/GetStats';
const GET_PAGE_VIEW = 'GoogleAnalytics/GetPageViews';
const GETG2FORMURL = 'EventService/GetG2FormUrl';
const GET_EVENTS_ANALYTICS = 'Report/GetAllEventForAnalytics';
const GET_EVENT_DETAILS = 'Report/GetEventTimeData';
const GET_BILLING_INFORMATION = 'UserService/GetBillingInformation';
const GET_VALIDATE_VERIFICATION_CODE = 'SettingService/ValidateVerificationCode';
const GET_SEND_VERIFICATION_CODE_FOR_PAYMENT_PROCESSOR_CHANGE =
  'SettingService/SendVerificationCodeForPaymentProcessorChange';
const CREATE_INSTANT_PAYOUT_PROMOTION_SESSION = 'EventService/CreateInstantPayoutPromoSession';
const LOG_ACCOUNT_SESSION_AUDIT_ASYNC = 'EventService/LogAccountSessionAuditAsync';
const MAINTENANCE_MODE_URL = 'EventService/GetDynamicConfigAsync';
const CREATE_EVENT_TIME_STATUS_URL = 'EventService/GetEventTimeCreationStatus';
const SOLD_TICKETS_STATS_URL = 'Dashboard/GetSoldTicketsStats';
const GET_SHOW_CATEGORY = 'EventService/GetShowCategory';
const GET_SHOW_DETAIL_URL = 'Dashboard/GetShowDetailUrl';
const DASHBOARD_DETAIL_URL = 'Report/GetDashBoardDetail';
const TOP_TIMES_AND_LOCATIONS_URL = 'Report/GetTopsTimesAndLocations';
const EVENT_SALES_AND_FEES_URL = 'Report/GetEventSalesAndFeeDetail';
const SQUARE_DONATION_SALES_AND_FEES_URL = 'Report/GetSquareDonationSalesAndFeeDetail';
const EVENT_TIME_AND_TICKET_INFO_URL = 'Report/GetEventTimeAndTicketInfo';
const SQUARE_DONATION_DETAILS_URL = 'Report/GetSquareDonationDetails';
const GET_PARTICIPANTS_URL = 'AttendeeManagement/GetParticipants';
const GET_ADVANCE_FILTER_URL = 'OrderManagement/GetAdvancedFilterOptions';
const GET_ATTENDEE_COUNT_URL = 'AttendeeManagement/GetAttendeeCount';
const GET_AUDIT_LOGS_LIST = 'SettingService/GetAuditLogsList';
const GET_EVENT_TIME_DATA_URL = 'AttendeeManagement/GetEventTimeData';
const GET_ORDER_MANAGEMENT_URL = 'OrderManagement/GetOrders';
const GET_ALL_ORDER_LIST_URL = 'OrderManagement/GetAllOrderList';
const GET_SALES_REPORT_URL = 'Report/GetReportByApplication';
const GET_PER_EVENT_SALES_REPORT_BY_SHOW_ID = 'Report/GetPerEventSalesReportByShowId';
const GET_SHOW_AND_TIME_DETAILS = 'Report/GetShowAndTimeDetails';
const GET_MAIN_SCAN_REPORT_URL = 'Report/GetScanReport';
const GET_SEASON_PASS_REPORT = 'Report/GetSeasonPassReportByApplication';
const GET_SEASON_PASS_DETAIL = 'Report/GetSeasonPassReportBySeasonPassId';
const GET_MAILCHIMP_CAMPAIGN_REPORT = 'Report/GetMailchimpCampaignReport';
const GET_SCHEDULED_REPORT_SETTINGS_URL = 'Report/GetScheduledReportSettings';
const SAVE_SCHEDULED_REPORT_SETTINGS_URL = 'Report/SaveScheduledReportSettings';
const GET_DONATION_REPORT_DETAILS_URL = 'Report/GetDonationReportDetails';
const GET_ACTIVE_EVENT_PREVIEWS_URL = 'EventService/GetActiveEventPreviews';
const EVENT_LEVEL_TICKET_SALE_ENABLED_FROM_TICKET_SETTINGS_URL = 'EventService/EventLevelTicketSaleEnabledFromTicketSettings';
const GET_TIME_IDS_FOR_EVENT_SECTIONS_NOT_ON_SALE = 'EventService/GetTimeIdsForEventSectionsNotOnSale';
const GET_SEND_ETICKETS_TO_ALL_ATTENDEES = 'AttendeeManagement/SendEticketsToAllAttendees';
const GET_SHARED_BOX_OFFICE_CONFIG_URL = 'AccountService/GetSharedBoxOfficeConfig';
const SAVE_SHARED_BOX_OFFICE_CONFIG_URL = 'AccountService/SaveSharedBoxOfficeConfig';
const GET_SETTINGS_URL = 'AccountService/GetSetting';
const GET_ATTENDEE_UPLOAD_TRACKER_FILTER_RECORDS = 'AttendeeManagement/GetAttendeeUploadTrackerFilterRecords';
const CHECK_GATEWAY_STATUS_URL = 'CommonService/CheckGatewayStatus';
const GETCURRENTPLAN_URL = 'SettingService/GetCurrentPlanDetail';
const GET_ATTENDEES_SCAN_HISTORY = 'AttendeeManagement/GetAttendeesScanHistory';
const GET_ADMINISTRATORS = 'UserService/GetAdministrators';
const REQUEST_OWNERSHIP_TRANSFER_OTP = 'UserService/RequestOwnershipTransferOTP';
const COMPLETE_OWNERSHIP_TRANSFER = 'UserService/CompleteOwnershipTransfer';
const GET_AMBASSADOR_DETAILS_URL = 'Ambassador/GetAmbassadorDetails';
const GET_AMBASSADOR_REFERRALS_URL = 'Ambassador/GetReferrals';
const CUSTOMER_CRM_URL = 'CustomerCRM';

const GET_GA_ADMISSION_DATA_REPORT_URL = 'Report/GetGaAdmissionDataReport';
const GET_RS_ADMISSION_DATA_REPORT_URL = 'Report/GetRsAdmissionDataReport';
const GET_FLEX_ADMISSION_DATA_REPORT_URL = 'Report/GetFlexAdmissionDataReport';
const EXPORT_ADMISSION_DATA_REPORT_CSV_URL = 'Report/ExportAdmissionDataReportCsv';

const DONOR_PERFECT_URL = 'DonorPerfect';
const MERCHANDISE_URL = '/Merchandise';
const EVENT_MERCHANDISE_URL = '/merchandise';
const GET_PRODUCT_SECTION_URL = 'SettingService/GetProductSection';

const GET_INTERNAL_EXCHANGE_OPTIONS_URL = 'GetInternalExchangeOptions';
const PROCESS_INTERNAL_EXCHANGE_URL = 'ProcessInternalExchange';
const GET_EXCHANGE_DESTINATION_DETAILS_URL = 'GetExchangeDestinationDetails';
const GET_EXCHANGE_HISTORY_URL = 'GetExchangeHistory';
const GET_EXCHANGE_ORDER_DETAILS_URL = 'GetExchangeOrderDetails';
const GET_CHARGEBACK_DISPUTE_DATA_URL = 'OrderManagement/GetChargebackDisputeData';
const REFUND_REQUEST_MANAGEMENT_URL = 'RefundRequestManagement';
const SELF_SERVICE_SETTINGS_URL = 'SelfServiceSettings';
const EXCLUDED_UPCOMING_SCHEDULE_PREVIEW_URL = 'preview-upcoming-schedule';

const BULK_REFUND_PREFLIGHT_URL = 'BulkRefund/Preflight';
const BULK_REFUND_STATUS_URL = 'BulkRefund/Status';
const BULK_REFUND_BATCHES_URL = 'BulkRefund/Batches';

export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  // Array of excluded URL patterns
  const excludedUrls = [
    EXCLUDED_UPCOMING_SCHEDULE_PREVIEW_URL,
    GET_CHARGEBACK_DISPUTE_DATA_URL,
    REFUND_REQUEST_MANAGEMENT_URL,
    SELF_SERVICE_SETTINGS_URL,
    EXCLUDED_URL,
    EXCLUDED_URL_CHATGPT_AI,
    EXCLUDED_URL_CHATGPT_AI_DELETE_RECORD,
    EXCLUDED_URL_FOR_ARCHIVE,
    GETPROMOCODE_URL,
    GETEVENT_URL,
    GETSELLTICKET_URL,
    CHECKSITESUSPENDED_URL,
    UPDATEVENUEMODIFYDATE_URL,
    ISDOMAINEXIST_URL,
    UPDATEEMBEDBUTTON_URL,
    COMMONDETAILS_URL,
    GETPAGEVIEWS_URL,
    CALCULATEAVAILABLESEAT_URL,
    GETPAGEDATA_URL,
    GETDASHBOARD_URL,
    GETATTENDEEMANAGEMENT_URL,
    BOXOFFICEPRINTETICKET_URL,
    GETTIMESLOTS_URL,
    GETIMPORTATTENDEES_URL,
    GETADMISSIONDETAIL_URL,
    SCANRESETTICKET_URL,
    GETEVENTINFOTOSWITCH,
    CHECKPREVALIDATIONTOTIME,
    GETPROMOCODES,
    EXCLUDED_GETEVENTIMAGESBYTITLE,
    GETACTIVEVENTPOSTEMAIL,
    GETSCANREPORT_URL,
    GETMAKETEMPLATEJSON_URL,
    GETGAANDRSEVENTSFORBOOKINGLAYOUT_URL,
    GETSTATES_URL,
    GET_PAGE_VIEW,
    GETG2FORMURL,
    GET_EVENTS_ANALYTICS,
    GET_EVENT_DETAILS,
    GET_VALIDATE_VERIFICATION_CODE,
    GET_SEND_VERIFICATION_CODE_FOR_PAYMENT_PROCESSOR_CHANGE,
    GET_BILLING_INFORMATION,
    CREATE_INSTANT_PAYOUT_PROMOTION_SESSION,
    LOG_ACCOUNT_SESSION_AUDIT_ASYNC,
    MAINTENANCE_MODE_URL,
    CREATE_EVENT_TIME_STATUS_URL,
    SOLD_TICKETS_STATS_URL,
    GET_SHOW_CATEGORY,
    GET_SHOW_DETAIL_URL,
    DASHBOARD_DETAIL_URL,
    TOP_TIMES_AND_LOCATIONS_URL,
    EVENT_SALES_AND_FEES_URL,
    SQUARE_DONATION_SALES_AND_FEES_URL,
    EVENT_TIME_AND_TICKET_INFO_URL,
    SQUARE_DONATION_DETAILS_URL,
    GET_PARTICIPANTS_URL,
    GET_ADVANCE_FILTER_URL,
    GET_ATTENDEE_COUNT_URL,
    GET_AUDIT_LOGS_LIST,
    GET_EVENT_TIME_DATA_URL,
    GET_ORDER_MANAGEMENT_URL,
    GET_SALES_REPORT_URL,
    GET_SHOW_AND_TIME_DETAILS,
    GET_PER_EVENT_SALES_REPORT_BY_SHOW_ID,
    GET_MAIN_SCAN_REPORT_URL,
    GET_SEASON_PASS_REPORT,
    GET_SEASON_PASS_DETAIL,
    GET_MAILCHIMP_CAMPAIGN_REPORT,
    GET_ALL_ORDER_LIST_URL,
    GET_SCHEDULED_REPORT_SETTINGS_URL,
    SAVE_SCHEDULED_REPORT_SETTINGS_URL,
    GET_ACTIVE_EVENT_PREVIEWS_URL,
    GET_TIME_IDS_FOR_EVENT_SECTIONS_NOT_ON_SALE,
    GET_SEND_ETICKETS_TO_ALL_ATTENDEES,
    GET_DONATION_REPORT_DETAILS_URL,
    GET_SHARED_BOX_OFFICE_CONFIG_URL,
    SAVE_SHARED_BOX_OFFICE_CONFIG_URL,
    GET_ATTENDEE_UPLOAD_TRACKER_FILTER_RECORDS,
    CHECK_GATEWAY_STATUS_URL,
    GET_ATTENDEES_SCAN_HISTORY,
    GET_ADMINISTRATORS,
    REQUEST_OWNERSHIP_TRANSFER_OTP,
    COMPLETE_OWNERSHIP_TRANSFER,
    GET_AMBASSADOR_DETAILS_URL,
    GET_AMBASSADOR_REFERRALS_URL,
    GET_GA_ADMISSION_DATA_REPORT_URL,
    GET_RS_ADMISSION_DATA_REPORT_URL,
    GET_FLEX_ADMISSION_DATA_REPORT_URL,
    EXPORT_ADMISSION_DATA_REPORT_CSV_URL,
    DONOR_PERFECT_URL,
    MERCHANDISE_URL,
    EVENT_MERCHANDISE_URL,
    GET_PRODUCT_SECTION_URL,
    CUSTOMER_CRM_URL,
    GET_INTERNAL_EXCHANGE_OPTIONS_URL,
    PROCESS_INTERNAL_EXCHANGE_URL,
    GET_EXCHANGE_DESTINATION_DETAILS_URL,
    GET_EXCHANGE_HISTORY_URL,
    GET_EXCHANGE_ORDER_DETAILS_URL,
    BULK_REFUND_PREFLIGHT_URL,
    BULK_REFUND_STATUS_URL,
    BULK_REFUND_BATCHES_URL
  ];


  // Route-based exclusions: URLs that should be excluded only on specific routes
  const routeBasedExclusions = [
    {
      url: EVENT_LEVEL_TICKET_SALE_ENABLED_FROM_TICKET_SETTINGS_URL,
      excludeOnRoutes: ['/general/event-list', '/general', '/general/', '/', '/event-list']
    },
    {
      url: GET_SETTINGS_URL,
      excludeOnRoutes: ['/general/account']
    },
    {
      url: GETCURRENTPLAN_URL,
      excludeOnRoutes: ['/general/event-list', '/general', '/general/', '/', '/event-list']
    }
  ];

  // Check if URL should be excluded based on route
  const isRouteBasedExcluded = routeBasedExclusions.some(exclusion => {
    try {
      if (req.url.includes(exclusion.url)) {
        // Check if current route matches any of the excluded routes
        return exclusion.excludeOnRoutes.some(route => {
          // Exact match or starts with route followed by query params or hash
          const currentUrl = router.url.split('?')[0].split('#')[0]; // Remove query params and hash
          return currentUrl === route || currentUrl === route.replace(/\/$/, ''); // Match with or without trailing slash
        });
      }
      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  });

  // Check if URL should be excluded
  const isExcluded =
    router.url.includes('general/exportable-reports') ||
    req.url.toLowerCase().includes('/ai/') ||
    excludedUrls.some(url => req.url.toLowerCase().includes(url.toLowerCase())) ||
    isRouteBasedExcluded ||
    (req.url.includes(PRINTBADGE_URL) && !req.url.includes(ATTENDEEBADGEPRINT_URL));

  if (isExcluded) {
    return next(req);
  }

  // Clone request if valid
  const clonedReq = req && req !== null ? req.clone() : req;

  // Get spinner service and start spinning
  const spinnerService = inject(SpinnerOverlayService);
  spinnerService.startSpinning();

  // Handle the request and stop spinning when complete
  return next(clonedReq).pipe(
    finalize(() => {
      spinnerService.stopSpinning();
    })
  );
};
